module.exports = __webpack_public_path__ + "assets/img/16_1814.e4c0f414.jpg";